// extracted by mini-css-extract-plugin
export default {"content":"_3gPex","code":"_3pA8m"};